
  <div class="calendar-grid">

    <div class="day-names">
      <div class="day-name" *ngFor="let dayName of dayNames">
        {{ dayName }}
      </div>
    </div>


    <div class="calendar-days">
      <div 
        class="calendar-day"
        *ngFor="let day of calendarDays"
        [class.other-month]="!day.isCurrentMonth"
        [class.today]="day.isToday"
        [class.selected]="day.isSelected"
        [class.has-orders]="day.orderCount > 0"
        (click)="selectDate(day)"
        [attr.aria-label]="day.date.toDateString()">
        
        <div class="day-content">
          <div class="day-header flex justify-content-between align-items-center">
            <span class="day-number">{{ day.date.getDate() }}</span>
            <p-badge 
              *ngIf="getOrdersForDate(day.date).length > 0"
              [value]="getOrdersForDate(day.date).length"
              severity="info">
            </p-badge>
          </div>
          
          <div class="orders-container" *ngIf="getOrdersForDate(day.date).length > 0">
            <div 
              class="order-square"
              *ngFor="let order of getOrdersForDate(day.date).slice(0, 3); let i = index"
              [class.status-unassigned]="order.load_status.toLowerCase() === 'unassigned'"
              [class.status-scheduled]="order.load_status.toLowerCase() === 'scheduled'"
              [class.status-loaded]="order.load_status.toLowerCase() === 'loaded'"
              [class.status-delivered]="order.load_status.toLowerCase() === 'delivered'"
              [pTooltip]="getCustomerName(order.supplier_id) + ' → ' + getCustomerName(order.receiver_id)"
              tooltipPosition="top">
              
              <div class="order-info">
                <div class="customer-info">
                  <span class="supplier">{{ getCustomerName(order.supplier_id).substring(0, 8) }}...</span>
                  <i class="pi pi-arrow-right"></i>
                  <span class="receiver">{{ getCustomerName(order.receiver_id).substring(0, 8) }}...</span>
                </div>
              </div>
            </div>
            
            <div class="order-overflow" *ngIf="getOrdersForDate(day.date).length > 3">
              +{{ getOrdersForDate(day.date).length - 3 }} more
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
